<template>
  <div>
    <el-form :model="formObject" :rules="rules" label-width="80px" ref="adDetailForm" size="mini">
      <el-form-item label="广告位置" prop="type" required>
        <el-select :disabled="type == 2" placeholder="广告位置" v-model="formObject.type">
          <el-option :key="item.id" :label="item.text" :value="item.id" v-for="item in locations"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="广告标题" prop="mainTitle" required>
        <el-input :readonly="type == 2" v-model="formObject.mainTitle"></el-input>
      </el-form-item>

      <el-form-item label="副标题" prop="subTitle" required>
        <el-input :readonly="type == 2" v-model="formObject.subTitle"></el-input>
      </el-form-item>

      <el-form-item label="状态" prop="flag" required>
        <el-radio-group :disabled="type == 2" v-model="formObject.flag">
          <el-radio label="1">启用</el-radio>
          <el-radio label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="内容类型" prop="urlType" required>
        <el-radio-group :disabled="type == 2" v-model="formObject.urlType">
           <el-radio label="8">新商城</el-radio>
          <el-radio label="1">商城详情</el-radio>
          <el-radio label="3">商城首页</el-radio>
          <el-radio label="2">抽奖</el-radio>
          <el-radio label="0">定制H5</el-radio>
          <el-radio label="4">普通H5</el-radio>
          <el-radio label="5">红包</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="发布时间" required>
        <el-col :span="11">
          <el-form-item prop="beginDate">
            <el-date-picker
              :readonly="type == 2"
              placeholder="开始时间"
              style="width: 100%;"
              type="datetime"
              v-model="formObject.beginDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="line txt-center">-</el-col>
        <el-col :span="11">
          <el-form-item prop="finishDate">
            <el-date-picker
              :readonly="type == 2"
              placeholder="结束时间"
              style="width: 100%;"
              type="datetime"
              v-model="formObject.finishDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>

      <el-form-item label="长期有效" prop="dateState" required>
        <el-radio-group :disabled="type == 2" v-model="formObject.dateState">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="上传图片" prop="imgUrl" required>
        <el-upload
          :before-upload="beforeUpload"
          :disabled="type == 2"
          :file-list="fileList"
          :limit="1"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          action="/file/upload"
          list-type="picture-card"
        ><i class="el-icon-plus"></i>
          <el-input v-model="formObject.imgUrl" v-show="false"></el-input>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img :src="formObject.imgUrl" alt width="100%">
        </el-dialog>
      </el-form-item>

      <el-form-item label="链接模板">
        <el-input
          :readonly="type == 2"
          placeholder="链接模板中应包含通配符*,例:http://*.mall.justbon.com.cn/item-7828.html"
          type="text"
          v-model="formObject.linkTemplate"
        ></el-input>
      </el-form-item>
    </el-form>
    <div>
      <h3 class="txt-center">项目列表</h3>
      <div v-if="type === 0 || type === 1">
        <el-popover placement="top-start" trigger="click" v-model="popShow" width="500">
          <!--项目穿梭框 START-->
          <el-transfer
            :data="projects"
            :filter-method="queryProject"
            :props="{key:'projectID',label:'name'}"
            filter-placeholder="请输入项目名称"
            filterable
            v-model="selectProjects"
          ></el-transfer>
          <!--项目穿梭框 END-->
          <div class="mgt-10 txt-right">
            <el-button @click="cancel" size="mini" type="text">取消</el-button>
            <el-button @click="select" size="mini" type="primary">确定</el-button>
          </div>

          <el-button icon="el-icon-edit" size="mini" slot="reference">编辑</el-button>
        </el-popover>
        <el-button @click="deleteItem" class="mgl-10" icon="el-icon-delete" size="mini">删除</el-button>


        <el-button @click="patchEdit" icon="el-icon-tickets" size="mini">批量编辑链接</el-button>
      </div>
      <el-table :data="formObject.projects" ref="projectList" stripe style="width: 100%">
        <el-table-column type="selection" v-if="type != 2" width="55"></el-table-column>
        <el-table-column label="名称" prop="projectName" width="300"></el-table-column>

        <!-- <el-table-column v-if="type == 2" prop="linkAdd" label="链接"></el-table-column> -->
        <el-table-column label="链接" prop="linkAdd" width>
          <template slot-scope="scope">
            <el-input :disabled="type == 2" placeholder="请输入链接" size="mini" v-model="scope.row.linkAdd"></el-input>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="dialog-footer mgt-10 txt-right">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button @click="finishDialog" size="small" type="primary" v-if="type != 2">确 定</el-button>
    </div>
  </div>
</template>

<script>
  import {bagTypes} from '@/components/advertising/adMixins'
  import {utils,Message} from "@/components";
  import moment from 'moment'

  export default {
    name: 'AdDetail',
    props: {
      formObject: {
        type: Object,
        required: true
      },
      // 0: 新增,1: 修改,2:查看
      type: {
        type: Number,
        default: 0
      }
    },
    watch: {
      type: function () {
        switch (this.type) {
          case 0:
            this.$refs['adDetailForm'].resetFields()
            break;
          default:
            break;
        }
      }
    },
    data() {
      return {
        dialogVisible: false,
        popShow: false,
        locations: bagTypes,
        projects: [],
        batchId: {},
        selectProjects: [],
        queryProject(query, item) {
          return item.name.indexOf(query) > -1;
        },
        rules: {
          type: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          mainTitle: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          subTitle: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          flag: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          urlType: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          beginDate: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          finishDate: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          dateState: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          imgUrl: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
        }
      }
    },
    created() {
      this.$store.dispatch('adbanner/getProjectsByUser').then(result => {
        this.projects = result
      })
      this.$store.dispatch("adbanner/getProjectsById").then(result => {
        this.batchId = result;
      })
    },
    computed: {
      fileList() {
        if (!this.formObject.imgUrl) return []
        return [{id: 0, url: this.formObject.imgUrl}]
      }
    },
    methods: {
      handleRemove() {
        this.formObject.imgUrl = ''
      },
      handleSuccess(res) {
        this.formObject.imgUrl = res.url
      },
      cancel() {
        this.popShow = false
      },
      select() {
        this.formObject.projects = []
        this.popShow = false
        this.projects.forEach(project => {
          if (this.selectProjects.indexOf(project.projectID) > -1) {
            var p = {
              projectName: project.name,
              projectId: project.projectID,
              linkAdd: ""
            };
            if (utils.isNotEmpty(this.formObject.id)) {
              p.adId = this.formObject.id;
            }
            this.formObject.projects.push(p);
          }
        })
      },
      handleClose() {
        this.$emit('close')
      },
      finishDialog() {
        this.$refs['adDetailForm'].validate((valid) => {
          if (valid) {
            this.formObject.beginDate = moment(this.formObject.beginDate).format('YYYY-MM-DD HH:mm:ss');
            this.formObject.finishDate = moment(this.formObject.finishDate).format('YYYY-MM-DD HH:mm:ss');
            this.$emit('finish')
            return true
          } else {
            Message.warning({message: '请正确填写表单项'})
            return false
          }
        })
      },
      beforeUpload(file) {
        let imgTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
        let type = file.type.toLowerCase();
        let isImage = imgTypes.indexOf(type) > -1;
        isImage || Message.warning('上传文件只能是 JPG,JPEG,PNG,GIF 格式');
        return isImage
      },
      repeatCheck(arr1, arr2) {
        return arr1.filter(item => {
          return !arr2.some(c => (c.projectId == item.projectId))
        })
      },
      deleteItem() {
        if (this.$refs.projectList.store.states.selection.length == 0) {
          Message.warning("请至少选择一条数据。");
          return;
        }
        let temp = JSON.parse(JSON.stringify(this.repeatCheck(this.formObject.projects, this.$refs.projectList.store.states.selection)));
        this.formObject.projects = temp;
        this.$forceUpdate();  //进行强制渲染
      },
      patchEdit() {

        if (this.formObject.linkTemplate == undefined) {
          this.formObject.linkTemplate = "";
        }
        let selectedData = this.$refs.projectList.store.states.selection;
        let temp = JSON.parse(JSON.stringify(this.formObject.linkTemplate));
        if (selectedData.length > 0) {
          let scope = this;
          selectedData.forEach(function (item) {
            if (scope.batchId[item.projectId]) {
              item.linkAdd = temp.replace("*", scope.batchId[item.projectId]);
            } else {
              item.linkAdd = temp.replace("*.", '');
            }
          });

        } else {
          Message.warning("请至少选择一条数据。")
        }
      }
      ,
    }
  };
</script>

<style scoped>
</style>
